import React from "react";
import {
  ModalWrapper,
  ModalContainer,
  Close,
} from "components/organisms/Modal/Modal.styles";
import { Paragraph } from "views/Step4.styles";
import RedButton from "components/atoms/RedButton/RedButton";
import GlobalData from "data/GlobalData";
export default function Modal({
  setShowModal,
  setStep,
  setFilledFields,
  setPrice,
  setSummary,
  setSelectedChallenges,
  lang,
  scrollToTopOfApp,
}) {
  function handleClose() {
    setShowModal(false);
    scrollToTopOfApp();
  }
  function handleAgain() {
    setSelectedChallenges([]);
    setFilledFields({});
    setPrice("");
    setSummary([]);
    setStep(1);
    scrollToTopOfApp();
  }
  return (
    <ModalWrapper>
      <ModalContainer>
        <Close onClick={handleClose}>&times;</Close>
        <Paragraph>
          <p className="text">
            <span className="text-warning">
              {lang === "pl"
                ? GlobalData.modal.warning.pl
                : GlobalData.modal.warning.en}
            </span>
            {lang === "pl"
              ? GlobalData.modal.text.pl
              : GlobalData.modal.text.en}
          </p>
        </Paragraph>
        <div className="buttons-wrapper">
          <RedButton onClick={() => handleClose()}>
            {lang === "pl"
              ? GlobalData.buttons.back.pl
              : GlobalData.buttons.back.en}
          </RedButton>
          <RedButton onClick={() => handleAgain()}>
            {" "}
            {lang === "pl"
              ? GlobalData.buttons.begin.pl
              : GlobalData.buttons.begin.en}
          </RedButton>
        </div>
      </ModalContainer>
    </ModalWrapper>
  );
}
